module.exports = __webpack_public_path__ + "img/home-icon.32cff739.svg";